import React from 'react';
import { Star } from 'lucide-react';
import { Section } from './Shared';
export interface TestimonialProps {
  initials: string;
  name: string;
  location: string;
  text: string;
  product?: string;
}
export const TestimonialCard = ({
  initials,
  name,
  location,
  text,
  product
}: TestimonialProps) => <div className="glass-panel p-6 md:p-8 rounded-2xl flex flex-col h-full border-brand-purple/15" data-id="element-419">
    <div className="flex items-center mb-4" data-id="element-420">
      <div className="w-9 h-9 md:w-12 md:h-12 rounded-full bg-brand-surfaceLight flex items-center justify-center text-brand-purple font-serif font-bold text-sm md:text-xl border border-brand-purple/30 mr-3 md:mr-4 shrink-0 shadow-sm" data-id="element-421">
        {initials}
      </div>
      <div data-id="element-422">
        <div className="flex text-brand-gold mb-1 text-[15px]" data-id="element-423">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-424" />)}
        </div>
        <div className="font-medium text-brand-text" data-id="element-425">{name}</div>
        <div className="text-xs text-brand-muted" data-id="element-426">
          {location} {product && `— ${product}`}
        </div>
      </div>
    </div>
    <p className="text-brand-text/90 italic flex-grow text-[13px] font-serif leading-relaxed" data-id="element-427">
      "{text}"
    </p>
  </div>;
export const InitialTestimonials = () => {
  const testimonials: TestimonialProps[] = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    text: 'La enciclopedia A-Z es una herramienta que no existía en ningún lado. Por primera vez tengo un recurso con base científica real sobre hierbas argentinas. Mis sesiones cambiaron completamente.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    text: 'El Tomo III de seguridad clínica me salvó de cometer errores graves con pacientes medicados. La tabla de interacciones sola vale todo el kit.'
  }, {
    initials: 'CP',
    name: 'Carolina P.',
    location: 'La Plata',
    text: 'El Recetario Maestro con las 48 fórmulas es lo que más uso en consulta. Tengo respuesta concreta para cada cuadro. Mis pacientes sienten la diferencia desde la primera semana.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-428">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-[12px]" data-id="element-429">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-430" />)}
      </div>
    </Section>;
};
export const MoreTestimonials = () => {
  const testimonials = [{
    initials: 'MG',
    name: 'María G.',
    location: 'Córdoba',
    product: 'Kit Saberes + Alquimia',
    text: 'La enciclopedia A-Z con el semáforo de seguridad me cambió la forma de prescribir. Ahora entro a cada consulta con certeza. Mis pacientes lo perciben desde el primer día.'
  }, {
    initials: 'JL',
    name: 'Julián L.',
    location: 'Buenos Aires',
    product: 'Herbolario',
    text: 'La tabla de interacciones del Tomo III debería ser obligatoria para cualquier terapeuta que trabaje con hierbas. Evité un error grave con un paciente anticoagulado. Eso no tiene precio.'
  }, {
    initials: 'SM',
    name: 'Sofía M.',
    location: 'Rosario',
    product: 'Estudiante avanzada',
    text: 'Recién empezaba y el kit me dio la estructura que necesitaba desde el primer paciente. No tuve que improvisar nada. El sistema hace el trabajo de años de experiencia.'
  }, {
    initials: 'DL',
    name: 'Diego L.',
    location: 'Tucumán',
    product: 'Médico naturista',
    text: 'El Módulo Alquimia Nativa me abrió un camino que no imaginaba. La espagiria vegetal combinada con fitococina argentina es un diferencial absoluto en mi práctica.'
  }];
  return <Section className="pt-8 pb-16" data-id="element-431">
      <div className="text-center mb-12" data-id="element-432">
        <h2 className="md:text-4xl font-display font-bold mb-4 text-[24px] text-brand-purpleDark pt-[0px]" data-id="element-433">
          ❤️ MÁS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-[12px] max-w-4xl mx-auto" data-id="element-434">
        {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-435" />)}
      </div>
    </Section>;
};